import { render, staticRenderFns } from "./SysBmAdForm.vue?vue&type=template&id=e99d8c7e&"
import script from "./SysBmAdForm.vue?vue&type=script&lang=js&"
export * from "./SysBmAdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e99d8c7e')) {
      api.createRecord('e99d8c7e', component.options)
    } else {
      api.reload('e99d8c7e', component.options)
    }
    module.hot.accept("./SysBmAdForm.vue?vue&type=template&id=e99d8c7e&", function () {
      api.rerender('e99d8c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/ad/modules/SysBmAdForm.vue"
export default component.exports